import { orgUserInviteSchema } from './orgUserInvite';
export const orgUserInviteInfoSchema = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInviteInfo',
    type: 'object',
    properties: {
        isTemp: { type: 'boolean' },
        orgUserInvites: { type: 'array', items: { $ref: orgUserInviteSchema.$id } }
    },
    required: ['isTemp', 'orgUserInvites']
};
//# sourceMappingURL=orgUserInviteInfo.js.map